import { render, staticRenderFns } from "./VibelaMark.vue?vue&type=template&id=ed2a070c&"
import script from "./VibelaMark.vue?vue&type=script&lang=js&"
export * from "./VibelaMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports